module.exports = __webpack_public_path__ + "media/images/connect_ad_small_logo-da67784cdbdc4c41a6d952f68e562634.png";